<template>
  <div>
    <div class="content-box" :style="{margin:`0 ${config.property_data.margin_num}px`,padding:`0 ${config.property_data.padding_num}px`,borderRadius: `${config.property_data.video_radius}px`,background:`${config.property_data.bg_color || 'none'}`}">
      <video
        ref="vedio"
        v-if="this.config.property_data.video_url"
        controls
        :poster="
          this.config.property_data.image_url ||
          'https://img.mockuai.com/tms/2018/1/13/upload_ed4e75f3608d59cbd803c5e3a98960af.png'
        "
        class="video"
        :style="{
          height: ratioHeight + 'px',
          borderRadius: config.property_data.radius + 'px',
        }"
      >
        <source :src="this.config.property_data.video_url" type="video/mp4" />
        您的浏览器不支持 video 标签。
      </video>

      <div v-else class="video-wrapper" :style="back_image_obj">
        <div class="masker">
          <div class="player">▶</div>
          <p>00:00</p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { debounce } from "@/js/debounce.js";
export default {
  name: "tms-video",
  props: ["config"],
  data() {
    return {
      ratioHeight: 175,
    };
  },

  components: {},
  mounted() {
    this.calcRatio();
  },
  methods: {
    calcRatio() {
      if (!/[1-9]:[1-9]/.test(this.radio)) {
        return;
      }
      if (!this.config.property_data.video_url) return;
      const width = this.$refs.vedio.getBoundingClientRect().width;
      const ratio = this.radio.split(":");
      let w = ratio[0];
      let h = ratio[1];
      this.ratioHeight = width / (w / h);
    },
  },
  computed: {
    back_image_obj() {
      let img_url =
        this.config.property_data.image_url ||
        "https://img.mockuai.com/tms/2018/1/13/upload_ed4e75f3608d59cbd803c5e3a98960af.png";
      return {
        backgroundImage: "url(" + img_url + ")",
        backgroundSize: this.config.property_data.image_url
          ? "contain"
          : "46px",
        height: this.ratioHeight + "px",
      };
    },
    radio() {
      return this.config.property_data.ratio;
    },
  },
  watch: {
    radio: {
      handler(val) {
        if (val) {
          debounce(this.calcRatio, 1000)();
        }
      },
    },
  },
};
</script>
<style  lang="scss" scoped>
@import "./index.scss";
</style>